import MaterialFilter from '~/material-filter'
import MaterialContent from '~/material-content'
import MaterialList from '~/material-list'
import MaterialEditor from '~/material-editor'
import Material from '~/material'
import QuestionSingle from '~/question-single'
import QuestionAssembly from '~/question-assembly'
import QuestionFilter from '~/question-filter'
import QuestionError from '~/question-error'
import QuestionTree from '~/question-tree'
import QuestionSimilar from '~/question-similar'
import HandoutFilter from '~/handout-filter'
import Upload from '~/upload'
import CloudUpload from '~/cloudUpload'
import TextToAudio from '~/text-to-audio'
import { $messageBox } from './utils/modus'
const components = [
  MaterialFilter,
  MaterialContent,
  MaterialList,
  MaterialEditor,
  Material,
  Upload,
  QuestionSingle,
  QuestionAssembly,
  QuestionFilter,
  QuestionError,
  QuestionTree,
  QuestionSimilar,
  HandoutFilter,
  CloudUpload,
  TextToAudio
]

const install = function (Vue, opts = {}) {
  components.map(component => {
    Vue.component(component.name, component)
  })
  Vue.prototype.$msgBox = $messageBox
}

/* istanbul ignore if */
if (typeof window !== 'undefined' && window.Vue) {
  install(window.Vue)
}

export default {
  install,
  version: '0.2.103',
  MaterialFilter,
  MaterialContent,
  MaterialList,
  MaterialEditor,
  Material,
  Upload,
  QuestionSingle,
  QuestionAssembly,
  QuestionFilter,
  QuestionError,
  QuestionTree,
  QuestionSimilar,
  HandoutFilter,
  CloudUpload,
  TextToAudio
}



// WEBPACK FOOTER //
// ./src/index.js